module.exports = __webpack_public_path__ + "static/media/personal-dosimetry.146b287b.svg";